import { render, staticRenderFns } from "./CompanyInfoNavigation.vue?vue&type=template&id=701bbcad&scoped=true&"
import script from "./CompanyInfoNavigation.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfoNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyInfoNavigation.vue?vue&type=style&index=0&id=701bbcad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701bbcad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701bbcad')) {
      api.createRecord('701bbcad', component.options)
    } else {
      api.reload('701bbcad', component.options)
    }
    module.hot.accept("./CompanyInfoNavigation.vue?vue&type=template&id=701bbcad&scoped=true&", function () {
      api.rerender('701bbcad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyInfoNavigation.vue"
export default component.exports